import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDMLsyjmMPikiLz752GKp_96nlxlAga3no",
  authDomain: "diary.litvill.com",
  projectId: "se-litvill",
  storageBucket: "se-litvill.firebasestorage.app",
  messagingSenderId: "44892985086",
  appId: "1:44892985086:web:0e6d8ca6a4fe8dcd56f7af",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
export const logOut = () => signOut(auth);